"use client";

import { Button } from "@offstreetparking/design-system/forms";
import { useState } from "react";
import { env } from "~/env";

export const EnvironmentBanner = () => {
	const [isHidden, setIsHidden] = useState(false);
	const enviro = env.NEXT_PUBLIC_ENVIRO;

	if (isHidden || !enviro || enviro === "production") {
		return null;
	}

	const label = enviro === "development" ? "DEV" : enviro.toUpperCase();

	return (
		<div className="relative">
			<div className="absolute top-0 right-0 left-0 z-40 flex w-full justify-center overflow-visible border-primary border-t">
				<Button
					className="h-auto rounded-t-none rounded-b px-2"
					isTight
					size="xs"
					onClick={() => setIsHidden(true)}
					type="button"
				>
					{label}
				</Button>
			</div>
		</div>
	);
};
